// src/admin/pages/AdminCategories.js
import React, { useEffect, useState, useContext } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { FaPlus, FaTrash } from "react-icons/fa";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import {
  getAdminCategoriesWithProducts,
  createAdminCategory,
  deleteAdminCategory, // ✅ NEW
} from "../../services/adminProducts.api";

function AdminCategories() {
  const { lang } = useContext(AdminLanguageContext);
  const [isOpen, setIsOpen] = useState(false);

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showAdd, setShowAdd] = useState(false);
  const [slug, setSlug] = useState("");
  const [nameEn, setNameEn] = useState("");
  const [nameAr, setNameAr] = useState("");

  // ✅ confirmation + toast
  const [confirmAction, setConfirmAction] = useState(null);
  const [toast, setToast] = useState("");

  const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");
const perms = JSON.parse(localStorage.getItem("staffPermissions") || {});
const isAdmin = adminUser.role === "admin";

const canAccess = isAdmin || perms.can_manage_products;

 useEffect(() => {
  if (!canAccess) return;
  load();
}, [canAccess]);


  const load = async () => {
    setLoading(true);
    const data = await getAdminCategoriesWithProducts();
    setCategories(data);
    setLoading(false);
  };

  // ---------- CREATE ----------
  const confirmCreate = () => {
    setConfirmAction({
      type: "create",
      message:
        lang === "AR"
          ? "هل أنت متأكد من إضافة هذا التصنيف؟"
          : "Are you sure you want to create this category?",
    });
  };

  const handleCreate = async () => {
    await createAdminCategory({
      slug: slug.trim(),
      name_en: nameEn.trim(),
      name_ar: nameAr.trim(),
    });

    setSlug("");
    setNameEn("");
    setNameAr("");
    setShowAdd(false);
    setConfirmAction(null);

    setToast(lang === "AR" ? "تم إنشاء التصنيف بنجاح" : "Category created successfully");
    load();
  };

  // ---------- DELETE ----------
  const confirmDelete = (id) => {
    setConfirmAction({
      type: "delete",
      id,
      message:
        lang === "AR"
          ? "هل أنت متأكد من حذف هذا التصنيف؟ سيتم إزالة الربط مع المنتجات."
          : "Are you sure you want to delete this category?",
    });
  };

  const handleDelete = async () => {
    await deleteAdminCategory(confirmAction.id);
    setConfirmAction(null);
    setToast(lang === "AR" ? "تم حذف التصنيف" : "Category deleted");
    load();
  };


  return (
    <div className={`flex bg-gray-100 min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className="flex-1 lg:ml-64">
        <AdminHeader setIsOpen={setIsOpen} />

        <main className="p-4 sm:p-6 max-w-5xl space-y-6">
        {!canAccess ? (
    <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
      <p className="text-red-700 font-semibold">
        {lang === "AR"
          ? "غير مصرح لك بإدارة التصنيفات"
          : "You are not allowed to manage categories"}
      </p>
    </div>
  ) : (
     <>
          {/* HEADER */}
          <div className="flex justify-between items-center">
            <h1 className="text-2xl font-bold text-cyan-700">
              {lang === "AR" ? "التصنيفات" : "Categories"}
            </h1>

            <button
              onClick={() => setShowAdd(true)}
              className="px-4 py-2 bg-cyan-600 text-white rounded-xl flex items-center gap-2"
            >
              <FaPlus /> {lang === "AR" ? "إضافة" : "Add Category"}
            </button>
          </div>

          {/* ADD CATEGORY */}
          {showAdd && (
            <div className="bg-white p-4 rounded-xl shadow space-y-3">
              <input
                placeholder="slug"
                value={slug}
                onChange={(e) => setSlug(e.target.value)}
                className="w-full p-3 border rounded-xl"
              />
              <input
                placeholder="Name (EN)"
                value={nameEn}
                onChange={(e) => setNameEn(e.target.value)}
                className="w-full p-3 border rounded-xl"
              />
              <input
                placeholder="Name (AR)"
                value={nameAr}
                onChange={(e) => setNameAr(e.target.value)}
                className="w-full p-3 border rounded-xl"
              />

              <div className="flex gap-3 justify-end">
                {/* ✅ CANCEL */}
                <button
                  onClick={() => setShowAdd(false)}
                  className="px-4 py-2 rounded-xl bg-gray-200 hover:bg-gray-300"
                >
                  {lang === "AR" ? "إلغاء" : "Cancel"}
                </button>

                <button
                  onClick={confirmCreate}
                  className="px-4 py-2 bg-green-600 text-white rounded-xl"
                >
                  {lang === "AR" ? "حفظ" : "Save"}
                </button>
              </div>
            </div>
          )}

          {/* LIST */}
          {loading ? (
            <div>Loading...</div>
          ) : (
            categories.map((c) => (
              <div key={c.id} className="bg-white rounded-xl shadow p-4">
                <div className="flex justify-between items-center mb-2">
                  <div className="font-bold">
                    {/* ✅ LANGUAGE SWITCH */}
                    {lang === "AR" ? c.name_ar : c.name_en}{" "}
                    <span className="text-sm text-gray-400">({c.slug})</span>
                  </div>

                  <div className="flex items-center gap-3">
                    <span className="text-sm text-gray-600">
                      {c.products_count}{" "}
                      {lang === "AR" ? "منتج" : "products"}
                    </span>

                    {/* ✅ DELETE */}
                    <button
                      onClick={() => confirmDelete(c.id)}
                      className="text-red-600 hover:text-red-700"
                    >
                      <FaTrash />
                    </button>
                  </div>
                </div>

                {c.products.length > 0 ? (
                  <ul className="list-disc pl-6 pr-3 text-sm text-gray-700">
                    {c.products.map((p) => (
                      <li key={p.id}>
                        {p.name_en}{" "}
                        <span className="text-gray-400">
                          ({p.public_id})
                        </span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div className="text-sm text-gray-400">
                    {lang === "AR" ? "لا توجد منتجات" : "No products"}
                  </div>
                )}
              </div>
            ))
          )}
          </>
            )}
        </main>
      </div>

      {/* ✅ CONFIRM MODAL */}
      {confirmAction && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-sm">
            <p className="text-sm text-gray-700 mb-6">
              {confirmAction.message}
            </p>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setConfirmAction(null)}
                className="px-4 py-2 rounded-xl bg-gray-200 hover:bg-gray-300"
              >
                {lang === "AR" ? "إلغاء" : "Cancel"}
              </button>

              <button
                onClick={
                  confirmAction.type === "create"
                    ? handleCreate
                    : handleDelete
                }
                className="px-4 py-2 rounded-xl bg-cyan-600 text-white hover:bg-cyan-700"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ TOAST */}
      {toast && (
        <div className="fixed top-6 right-6 z-50 bg-green-600 text-white px-5 py-3 rounded-xl shadow-lg text-sm font-semibold">
          {toast}
          {setTimeout(() => setToast(""), 2000)}
        </div>
      )}
    </div>
  );
}

export default AdminCategories;
